import { Market, ReminderJourneyOverride, ReminderJourneys, SentJourneyLog } from 'generated/event.types';

export enum PerformanceStatus {
  success = 'success',
  failed = 'failed',
  pending = 'pending',
  na = 'na',
}

export type PerformanceColumn = {
  key: string;
  label: string;
  status: PerformanceStatus;
  useYesNo?: boolean;
  customValue?: string;
};

export type PerformanceSectionProps = {
  sentJourneyLogs?: SentJourneyLog[];
  attendedZoom?: boolean;
  attendedZoomDuration?: number;
  registrationEmailSent?: boolean;
  eventStartDate?: Date | string;
  eventEndDate?: Date | string;
  eventMarket?: Market;
  journeys?: ReminderJourneys[];
  reminderOverrides?: ReminderJourneyOverride[];
};
